import { connect } from "react-redux";

import StandardsList from "../components/standards_list";
import { tableMainStandardsSorted, tableMainStandardsPage } from "../actions/filters";

const defaultGetStandards = state => state.loading.data.regulationStandards;

export default (getStandards = defaultGetStandards) => {
  const mapStateToProps = (state) => {
    const standards = getStandards(state);
    const page = state.filters.tables.mainRegulationStandards.page;
    const sorted = state.filters.tables.mainRegulationStandards.sorted;
    const totalResults = state.loading.data.mainRegulationStandardsTotal;
    const pageSize = state.loading.data.mainRegulationStandardsPageSize;

    const parameterFocused = !!state.filters.focusParameterId.id;
    const regulationFocused = !!state.filters.focusRegulationId.id;
    return { standards, page, sorted, totalResults, pageSize, parameterFocused, regulationFocused };
  };

  const mapDispatchToProps = dispatch => ({
    onPageChange: (e) => dispatch(tableMainStandardsPage(e)),
    onSortedChange: (e) => dispatch(tableMainStandardsSorted(e))
  });

  return connect(mapStateToProps, mapDispatchToProps)(StandardsList);
};
